<template>
  <div class="popup-main">
    <el-dialog
      :title="detailId ? '编辑职位' : '新增职位'"
      width="800px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
    >
      <div>
        <div v-if="loaded">
          <div class="department-box">
            <div class="t-a-r" style="width: 240px">
              <span class="m-r-4 c-red">*</span>
              <span class="m-r-5 c-black">所属组织</span>
            </div>
            <b-organize-staff :data.sync="selfData.department_data" width="1288px" />
          </div>
          <e-form
            ref="refForm"
            :config="formConfig"
            :column="formColumn"
            :rules="formRules"
            :data.sync="selfData"
          />
        </div>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    detailId: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      loaded: false,
      selfShow: false,
      selfData: {
        id: '',
        department_ids: [],
        department_data: {},
        code: '',
        name: '',
        job_do_id: '',
        job_level_id: '',
        category_ids: [],
        remark: '',
        status: true
      },
      formConfig: {
        inline: false,
        width: '100%'
      },
      formColumn: [
        {
          type: 'text',
          title: '职位编码',
          placeholder: '自动生成',
          field: 'code',
          disabled: true
        },
        {
          type: 'text',
          title: '职位名称',
          field: 'name',
          required: true
        },
        {
          type: 'select',
          title: '所属职务',
          field: 'job_do_id',
          options: []
        },
        {
          type: 'select',
          title: '所属职级',
          field: 'job_level_id',
          options: []
        },
        {
          type: 'category',
          title: '职位分类',
          field: 'category_ids',
          url: '/admin/gcvip/gangWeiFenLei2/list'
        },
        {
          type: 'text',
          title: '职位描述',
          field: 'remark'
        },
        {
          type: 'switch',
          title: '状态',
          field: 'status'
        }
      ],
      formRules: {
        name: [{ required: true, message: '请输入职位名称' }]
      }
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    if (this.detailId) {
      this.getDetailData()
    } else {
      this.loaded = true
    }
    this.getJobDoList()
    this.getJobLevelList()
  },
  methods: {
    // 获取详情数据
    async getDetailData() {
      this.loaded = false
      await this.$api({
        method: 'get',
        url: '/admin/gcvip/gangwei2/detail',
        params: {
          id: this.detailId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data.data)
          this.selfData = result
        }
      })
      this.loaded = true
    },
    // 获取职务列表数据
    async getJobDoList() {
      await this.$api({
        method: 'post',
        url: '/admin/gcvip/zhiwu2/list',
        data: {
          filterData: {},
          pageSize: this.$constant.pageMax
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = res.data.page.list.map((item) => {
            return {
              key: item.name,
              val: item.id,
              disabled: item.status === false
            }
          })
          this.formColumn.forEach((item) => {
            if (item.field === 'job_do_id') item.options = result
          })
        }
      })
    },
    // 获取职级列表数据
    async getJobLevelList() {
      await this.$api({
        method: 'post',
        url: '/admin/gcvip/zhiJi2/list',
        data: {
          filterData: {},
          pageSize: this.$constant.pageMax
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = res.data.page.list.map((item) => {
            return {
              key: item.name,
              val: item.id,
              disabled: item.status === false
            }
          })
          this.formColumn.forEach((item) => {
            if (item.field === 'job_level_id') item.options = result
          })
        }
      })
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.$refs.refForm.$refs.refForm.validate((valid) => {
        if (valid) {
          this.$api({
            method: 'post',
            url: '/admin/gcvip/gangwei2/saveOrUpdate',
            data: {
              form_data: {
                ...this.selfData,
                department_ids: this.selfData.department_data.department_list.map((item) => item.id)
              }
            }
          })
            .then((res) => {
              if (res.data.state === 'ok') {
                this.popupCancel()
                this.$emit('success')
                this.$message.success('保存成功')
              }
            })
            .catch(() => {})
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
  .department-box {
    position: relative;
    z-index: 99;
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>
